import { useEffect, useState } from 'react';
import apiClient from '../../../../utils/apiClient';
import { useForm } from 'react-hook-form';
import FormSubmitButton from '../../../forms/form-control/FormSubmitButton';
import FormInputDate from '../../../forms/form-control/FormInputDate';
import FormSearchableSelect from '../../../forms/form-control/FormSearchableSelect';

/**
 * Fuel report filters.
 * @returns {JSX.Element}
 * @constructor 
 */
const FuelReportFilters = (prop) => {
    const { setIsLoading } = prop;
    const [clients, setClients] = useState([]);
    const { control, register, handleSubmit, errors, watch, setValue } = useForm();
    const [jobs, setJobs] = useState([]);

    const clientId = watch('client_id')?.value;
    const jobId = watch('job_id')?.value;

    useEffect(() => {
        if (clientId) {
            apiClient
                .post('getActiveJobsByClientId', {client_id: clientId})
                .then(response => {
                    setJobs(
                        response.data.jobs.map(
                            ({id, job_number}) => ({value: id, label: job_number})
                        )
                    )
                })
        }
    }, [clientId]);

    useEffect(() => {
        setValue('job_id', null);
    }, [clientId, setValue]);

    useEffect(() => {
        apiClient
            .get('getActiveClientsList')
            .then(response => {
                setClients(
                    response.data.activeClientsList.map(
                        ({id, client_name}) => ({value: id, label: client_name})
                    )
                );
            });
    }, [setClients]);

    const onDownload = (data) => {
        setIsLoading(true);
        const params = {
            client_id: data.client_id?.value,
            job_id: data.job_id?.value,
            date_from: data.date_from,
            date_to: data.date_to,
        }
        apiClient('exportFuelReport', {
            method: 'POST',
            responseType: 'blob',
            data: params,
        })
            .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const a = document.createElement('a');
                a.href = url;
                a.download = 'export_fuel_report.xlsx';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                setIsLoading(false);
            }).catch(function() {
                setIsLoading(false);
            })
    }

    return (
        <form 
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onDownload)}
        >
            <div className="form-row row s-gy">
                <FormSearchableSelect 
                    id="client_id"
                    label="Client"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                    rules={{required: "required"}}
                    options={clients}
                    control={control}
                    errors={errors}
                />
                <FormSearchableSelect 
                    id="job_id"
                    label="Job"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-3"
                    value={jobId}
                    options={jobs}
                    control={control}
                    errors={errors}
                />
                <FormInputDate 
                    id="date_from"
                    label="From"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormInputDate 
                    id="date_to"
                    label="To"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    register={register({required: "required"})}
                    errors={errors}
                />
                <FormSubmitButton 
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Download"
                />
            </div>
        </form>
    )
}

export default FuelReportFilters;
